export const TRACKED_COMPETITORS_SECTION = "tracked-competitors";
// Appearance rates below 0.5 round to 0 in the UI, so those competitors are treated as
// "absolute zeros": no dot on the chart line, no rank, and no best-performing / most-cited details.
export const ABSOLUTE_ZERO_APPEARANCE_RATE_THRESHOLD = 0.5;
// The Number.isFinite guard keeps null, undefined, and NaN on the absolute-zero side —
// bare comparison would treat null (coerced to 0) and undefined (NaN comparison) differently.
export const isAbsoluteZero = (competitor) => !Number.isFinite(competitor.appearanceRate) || competitor.appearanceRate < ABSOLUTE_ZERO_APPEARANCE_RATE_THRESHOLD;
